export const ALERT_MANAGER_ROUTE = {
  TITLE: "Alerts",
  KEY: "alertManager",
  ABSOLUTE_PATH: "/alert-manager",
  PARENT_PATH: "alert-manager/*",
};
